/* eslint-disable */
//不使用JQuery版的
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';

/**
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  padfName     PDF文件生成后的文件名字
 * */

function downloadPDF(ele, pdfName) {

	let eleW = ele.offsetWidth; // 获得该容器的宽
	let eleH = ele.offsetHeight; // 获得该容器的高
	let eleOffsetTop = ele.offsetTop; // 获得该容器到文档顶部的距离
	let eleOffsetLeft = ele.offsetLeft; // 获得该容器到文档最左的距离

	var canvas = document.createElement("canvas");
	var abs = 0;

	let win_in = document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
	let win_out = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）

	if (win_out > win_in) {
		// abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
		abs = (win_out - win_in) / 2; // 获得滚动条宽度的一半
		// console.log(a, '新abs');
	}
	canvas.width = eleW * 2; // 将画布宽&&高放大两倍
	canvas.height = eleH * 2;

	var context = canvas.getContext("2d");
	context.scale(2, 2);
	context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
	// 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
	// translate的时候，要把这个差值去掉

	// html2canvas(element).then( (canvas)=>{ //报错
	// html2canvas(element[0]).then( (canvas)=>{
	html2canvas(ele, {
		dpi: 300,
		// allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
		useCORS: true, //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
		allowTaint: true,
	}).then((canvas) => {
		var contentWidth = canvas.width;
		var contentHeight = canvas.height;

		//一页pdf显示html页面生成的canvas高度;
		var pageHeight = contentWidth / 592.28 * 841.89;
		//未生成pdf的html页面高度
		var leftHeight = contentHeight;
		//页面偏移
		var position = 0;
		//a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
		var imgWidth = 595.28;
		var imgHeight = 592.28 / contentWidth * contentHeight;
		var pageData = canvas.toDataURL('image/jpeg', 1.0);
		var pdf = new JsPDF('', 'pt', 'a4');
		//有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
		//当内容未超过pdf一页显示的范围，无需分页
		if (leftHeight < pageHeight) {
			pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
		} else {
			while (leftHeight > 0) {
				pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
				leftHeight -= pageHeight;
				position -= 841.89;
				//避免添加空白页
				if (leftHeight > 0) {
					pdf.addPage();
				}
			}
		}
		//可动态生成
		pdf.save(pdfName);
		let emptyDivs = document.getElementsByClassName('emptyDiv');
		for (let i = 0; i < emptyDivs.length; i++) {
			let parent = emptyDivs[i].parentNode;
			parent.removeChild(emptyDivs[i]);
		}
	})
}


//避免分页被截断
function outPutPdfFn(ele, pdfName) {
	const A4_WIDTH = 592.28;
	const A4_HEIGHT = 841.89;
	// $myLoading 自定义等待动画组件，实现导出事件的异步等待交互
	// dom的id。
	let target = ele;
	let pageHeight = target.scrollWidth / A4_WIDTH * A4_HEIGHT;
	// 获取分割dom，此处为class类名为item的dom
	let lableListID = document.getElementsByClassName('item');
	// 进行分割操作，当dom内容已超出a4的高度，则将该dom前插入一个空dom，把他挤下去，分割
	for (let i = 0; i < lableListID.length; i++) {
		let multiple = Math.ceil((lableListID[i].offsetTop + lableListID[i].offsetHeight) / pageHeight);
		if (isSplit(lableListID, i, multiple * pageHeight)) {
			let divParent = lableListID[i].parentNode; // 获取该div的父节点
			let newNode = document.createElement('div');
			newNode.className = 'emptyDiv';
			newNode.style.background = '#ffffff';
			let _H = multiple * pageHeight - (lableListID[i].offsetTop + lableListID[i].offsetHeight);
			newNode.style.height = _H + 100 + 'px';
			newNode.style.width = '100%';
			let next = lableListID[i].nextSibling; // 获取div的下一个兄弟节点
			// 判断兄弟节点是否存在
			//console.log(next);
			if (next) {
				// 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
				divParent.insertBefore(newNode, next);
			} else {
				// 不存在则直接添加到最后,appendChild默认添加到divParent的最后
				divParent.appendChild(newNode);
			}
		}
	}
	this.downloadPDF(ele, pdfName);
}
// 判断是否需要添加空白div
function isSplit(nodes, index, pageHeight) {
	// 计算当前这块dom是否跨越了a4大小，以此分割
	if (nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight && nodes[index + 1] && nodes[index + 1]
		.offsetTop + nodes[index + 1].offsetHeight > pageHeight) {
		return true;
	}
	return false;
}


/**
 * 网络图像文件转Base64
 */
function getBase64(imgurl) {
	window.URL = window.URL || window.webkitURL;
	var xhr = new XMLHttpRequest();
	xhr.open("get", imgurl, true);
	// 至关重要
	xhr.responseType = "blob";
	xhr.onload = function() {
		if (this.status == 200) {
			//得到一个blob对象
			var blob = this.response;
			console.log("blob", blob)
			// 至关重要
			let ofileReader = new fileReader();
			ofileReader.onloadend = function(e) {
				// 此处拿到的已经是 base64的图片了
				let base64 = e.target.result;
				console.log("方式一》》》》》》》》》", base64)
			};
			ofileReader.readAsDataURL(blob);
			//====为了在页面显示图片，可以删除====
			var img = document.createElement("img");
			img.onload = function(e) {
				window.URL.revokeObjectURL(img.src); // 清除释放
			};
			let src = window.URL.createObjectURL(blob);
			img.src = src
			//document.getElementByID("container1").appendChild(img);
			//====为了在页面显示图片，可以删除====
		}
	}
	xhr.send();
}

export default {
	downloadPDF,
	getBase64,
	outPutPdfFn
}
